export const ACCOUNT_DETAILS_TABS_VALUE = {
  SUMMARY: "summary",
  HOMES: "homes",
  CONTACTS: "contacts",
  USERS: "users",
  SUPPRESSED_WORK: "suppressed-work",
};
